export const FILTER_MIN_GARMENTS_COUNT = 2;

export const FILTER_MAX_GARMENTS_COUNT = 7;

export const MIN_LOOKS_LEFT_TO_LOAD_NEW = 5;

export const GARMENTS_IN_LOOK_PREVIEW_FOR_PC = 4;
export const GARMENTS_IN_LOOK_PREVIEW_FOR_PC_S = 3;
export const GARMENTS_IN_LOOK_PREVIEW_FOR_TABLETS = 2;

export const MIN_PC_BODY_WIDTH = 1312;
export const MIN_PC_S_BODY_WIDTH = 935;
export const MIN_TABLET_BODY_WIDTH = 616;
export const MIN_MOBILE_BODY_WIDTH = 325;

export const FILTER_COLOR_OPTIONS = [
  { value: 'GOLD', label: 'GOLD' },
  { value: 'WHITE', label: 'WHITE' },
  { value: 'BLUE', label: 'BLUE' },
  { value: 'PURPLE', label: 'PURPLE' },
  { value: 'GREEN', label: 'GREEN' },
  { value: 'RED', label: 'RED' },
  { value: 'PINK', label: 'PINK' },
  { value: 'NEUTRALS', label: 'NEUTRALS' },
  { value: 'BLACK', label: 'BLACK' },
  { value: 'YELLOW', label: 'YELLOW' },
  { value: 'MULTICOLOUR', label: 'MULTICOLOUR' },
  { value: 'BROWN', label: 'BROWN' },
  { value: 'GREY', label: 'GREY' },
  { value: 'ORANGE', label: 'ORANGE' },
];
